import { faCircleCheck, faCircleQuestion, faPaperPlane } from "@fortawesome/pro-solid-svg-icons"
import theme from "css/theme/light"
import { IDeviationStatusProps } from "pages/deviation/deviation.interface"

export const statusOptions: Array<{ label: string; value: number }> = [
  { label: "Ny", value: 0 },
  { label: "Tilldelad", value: 1 },
  { label: "Pågående", value: 4 },
  { label: "Avslutad", value: 2 }
]

export const deviationStatusProps = (id: number, t?: any) => {
  switch (id) {
    case 0:
      return {
        key: "global.unmanaged",
        title: "Ohanterad",
        icon: faCircleQuestion,
        color: theme.palette.grey[600],
        description: ""
      } as IDeviationStatusProps
    case 1:
      return {
        key: "global.assigned",
        title: "Tilldelad",
        icon: faPaperPlane,
        color: theme.palette.primary["main"],
        description: ""
      } as IDeviationStatusProps
    case 2:
      return {
        key: "global.managed",
        title: "Hanterad",
        icon: faCircleCheck,
        color: theme.palette.success["main"],
        description: ""
      } as IDeviationStatusProps
    default:
      return {
        key: "global.unmanaged",
        title: "Ohanterad",
        icon: faCircleQuestion,
        color: theme.palette.grey[600],
        description: ""
      } as IDeviationStatusProps
  }
}

export const deviationStatusStrings = (value: number, t: any) => {
  switch (value) {
    case 0:
      return t("global.new", "New")
    case 1:
      return t("global.assigned", "Assigned")
    case 2:
      return t("global.completed", "Completed")
    case 4:
      return t("global.ongoing", "On Going")
    default:
      return t("global.unmanaged", "Unmanaged")
  }
}